import { gql } from "@apollo/client";

export const UPDATE_INSTANCIA_LOGISTICA = gql`
    mutation UpdateInstanciaLogistica(
        $idEstado: Int!
        $idEvaluacion: Int!
        $idMotivo: Int!
        $alertarZonaDesfavorable: Boolean!
        $motivo: String
        $idDistribuidor: Int!
    ){
        updateInstanciaLogistica(input:{
            idEstado: $idEstado
            idEvaluacion: $idEvaluacion
            idMotivo: $idMotivo
            alertarZonaDesfavorable: $alertarZonaDesfavorable
            motivo: $motivo
            idDistribuidor: $idDistribuidor
        }){
            nroInstancia
        }
    }
`;